export enum FxConversion {
  NOT_CONVERTED = 'Not Converted',
  UNHEDGED = 'Unhedged',
  MONTHLY_HEDGED = 'Monthly Hedged',
  HEDGED_WITH_CASH_DAILY = 'Hedged With Cash Daily',
  HEDGED_WITH_CASH_AT_REBALANCING = 'Hedged With Cash At Rebalancing',
}
